<template lang="pug">
.edi-template
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{$t('GenerateData.generateDataTemplate')}}
    v-row
      v-col(cols="6")
        v-select(
          :label="$t('GenerateData.entityToBeGenerated')",
          :value="(value || {}).entity",
          :items="schema",
          item-text="name",
          item-value="name",
          @input="selectEntity",
        )
    code-editor(
      v-model="instance.body",
      language="application/json"
    )
</template>

<style type="text/css">
span.text-size{
  overflow: hidden;
}
</style>

<script>

export default {
  props: ['value'],
  data: function ()  {
    return {
      initObject: {
        type: 'Generate Data',
        body: '',
        entity: '',
        isRazor: true
      },
      instance: {}
    }
  },
  computed: {
    schema() {
      return this.$store.state.schema.all;
    },
  },
  watch: {
    instance: {
      deep: true,
      handler(val) {
        val.entity = this.value.entity
        this.$emit('input', val)
      },
    },
  },
  methods: {
    selectEntity(val) {
      const input = { ...this.initObject, ...this.value, entity: val };
      this.$emit('input', input);
    },
  },
  created() {
    this.instance = { ...this.initObject, ...this.value };
  },
}
</script>
